export enum SearchType {
	ADDRESS = "address",
	PARCEL = "parcel",
	TRANSACTION = "transaction",
	OPPORTUNITY = "opportunity",
}

const parcelPattern = /^(PC-\d+|\d+)$/
const addressPattern = /[a-zA-ZÀ-ÿ]/
const opportunityPattern = /^\d{8,}$/
const standaloneTransactionPattern = /^(?:\d{2}\s\d{3}\s\d{3}|\d{8})$/
const assemblyTransactionPattern = /^(?:\d{3}(?:\s\d{3}){4}|\d{15})$/

function isTransactionInput(input: string): boolean {
	const trimmedInput = input.trim()

	return standaloneTransactionPattern.test(trimmedInput) || assemblyTransactionPattern.test(trimmedInput)
}

export function normalizeTransactionInscriptionNumber(input: string): string {
	const digits = (input ?? "").replace(/\D+/g, "")

	if (digits.length === 8) {
		return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)}`
	}

	if (digits.length === 15) {
		return digits
	}

	return input
}

export function detectSearchType(input: string): SearchType | null {
	if (!input.trim()) {
		return null
	}

	const trimmedInput = input.trim()

	if (isTransactionInput(trimmedInput)) {
		return SearchType.TRANSACTION
	}

	if (opportunityPattern.test(trimmedInput)) {
		return SearchType.OPPORTUNITY
	}

	if (parcelPattern.test(trimmedInput)) {
		return SearchType.PARCEL
	}

	if (addressPattern.test(input)) {
		return SearchType.ADDRESS
	}

	return null
}
